import AICloudDeveloperPage from "./AICloudDeveloperPage";

export default function AIMLDeveloperPage() {
  return <AICloudDeveloperPage technology="ai-ml" />;
}
